import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IRootState } from "../state";
import { stepperActions } from "../state/stepper";

const useStepNavigation = () => {
  const { activeStep } = useSelector((state: IRootState) => state.stepper);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const setNext = (path: string) => {
    dispatch(stepperActions.setStepperAction({
      activeStep: 0,
      stepName: path,
    }));
    navigate(`${path}`);
  };

  return {
    activeStep,
    setNext,
  };
};

export default useStepNavigation;

